import api from './client';

export interface ExitIntentPopupSettings {
  enabled: boolean;
  headline: string;
  body: string;
  discount_code: string | null;
  button_text: string;
  trigger_delay_seconds: number;
  suppress_after_conversion_days: number;
  reshow_after_dismiss_days: number;
  excluded_page_types: string[];
}

export const EXCLUDABLE_PAGE_TYPES: { value: string; label: string }[] = [
  { value: 'cart', label: 'Cart page' },
  { value: 'customers/account', label: 'Account dashboard' },
  { value: 'customers/login', label: 'Login page' },
  { value: 'customers/register', label: 'Registration page' },
  { value: 'password', label: 'Password / coming soon page' },
];

export interface PopupLead {
  id: number;
  email: string;
  source: string;
  created_at: string | null;
}

export const exitIntentPopupApi = {
  show: () => api.get<{ data: { settings: ExitIntentPopupSettings; leads_count: number } }>('/exit-intent-popup'),

  update: (settings: ExitIntentPopupSettings) =>
    api.put<{ data: ExitIntentPopupSettings }>('/exit-intent-popup', settings),

  leads: (page = 1) =>
    api.get<{ data: PopupLead[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/exit-intent-popup/leads?page=${page}`
    ),
};
